module.exports = __webpack_public_path__ + "img/QCcheckout_S1Page.d73a4ecc.png";